document.addEventListener('DOMContentLoaded', () => {
    const marquees = document.querySelectorAll('.rethinking-stress__marquee');

    marquees.forEach((marquee) => {
        const track = marquee.querySelector('.rethinking-stress__track');
        if (!track) return;

        let rawSpeed = parseFloat(track.dataset.speed) || 3;
        let baseSpeed = rawSpeed / 20; // 1 = 0.05px/frame (very slow), 10 = 0.5px/frame (fast)
        let isHovered = false;
        let offset = 0;
        let trackWidth = 0;

        // Calculate original content width.
        // Since we duplicated the blocks inside the template, the container 
        // is actually double the size of the original content.
        // We calculate half the scrollWidth.
        const calculateWidth = () => {
            // get real gap from CSS
            const gap = parseInt(getComputedStyle(track).getPropertyValue('--track-gap')) || 30;
            trackWidth = (track.scrollWidth + gap) / 2;
        };

        // Recalculate on resize
        window.addEventListener('resize', calculateWidth);
        // Give browser time to paint before initial calc
        setTimeout(calculateWidth, 100);

        marquee.addEventListener('mouseenter', () => isHovered = true);
        marquee.addEventListener('mouseleave', () => isHovered = false);

        function tick() {
            if (!trackWidth) {
                requestAnimationFrame(tick);
                return;
            }

            // If not hovered, keep moving automatically
            if (!isHovered) {
                offset += baseSpeed;
            }

            // Infinite loop logic
            if (offset >= trackWidth) {
                offset -= trackWidth;
            } else if (offset <= 0) {
                offset += trackWidth;
            }

            track.style.transform = `translate3d(${-offset}px, 0, 0)`;
            requestAnimationFrame(tick);
        }

        requestAnimationFrame(tick);
    });
});
